import React from 'react';

export default function SignatureSelectedIcon({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.25 8.74907C13.75 11.2491 11.865 13.6031 9.21998 14.1291C7.92997 14.386 6.59179 14.2293 5.39598 13.6815C4.20018 13.1336 3.2077 12.2224 2.55988 11.0777C1.91205 9.93291 1.6419 8.61296 1.78789 7.30574C1.93388 5.99853 2.48857 4.77069 3.37298 3.79707C5.18698 1.79907 8.24998 1.24907 10.75 2.24907"
        stroke="#7F38E9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.75 7.75L8.25 10.25L14.25 3.75"
        stroke="#7F38E9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
